var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask", on: { mousedown: _vm.dontClose } }, [
      _c("div", { staticClass: "modal-wrapper grayBackground" }, [
        _c("div", { staticClass: "modal-container modal-container-40" }, [
          _c(
            "div",
            {
              staticClass: "modal-body m-0",
              style: { maxHeight: _vm.getMaxHeightClient() + "px" },
            },
            [
              _c(
                "div",
                {
                  attrs: { slot: "formcontent" },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.quickChangePassword()
                    },
                  },
                  slot: "formcontent",
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "panel-heading" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "formTitleBlock",
                          attrs: { cols: "10" },
                        },
                        [
                          _c(
                            "h4",
                            { staticClass: "content-block labelAccordionForm" },
                            [
                              _c("i", {
                                staticClass: "fa-light fa-lock mr-2",
                                staticStyle: { "font-size": "20px" },
                              }),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t("administration.renew_password")
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            "b-dropdown",
                            {
                              attrs: {
                                left: "",
                                "toggle-class":
                                  "border-0 p-0 bg-none m-md-2 text-dark",
                              },
                              model: {
                                value: _vm.language,
                                callback: function ($$v) {
                                  _vm.language = $$v
                                },
                                expression: "language",
                              },
                            },
                            [
                              _c("template", { slot: "button-content" }, [
                                _c("img", {
                                  staticClass: "flag-nav",
                                  attrs: {
                                    src:
                                      _vm.language === "FR"
                                        ? _vm.logoFlagFR
                                        : _vm.logoFlagEN,
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "d-none-max-1459px mr-1" },
                                  [_vm._v(_vm._s(_vm.labelLanguage))]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.langOptions, function (option) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: option.value,
                                    staticClass: "dropdown-item-web-header",
                                    on: {
                                      click: function ($event) {
                                        return _vm.languageCountry(option.value)
                                      },
                                    },
                                  },
                                  [
                                    option.value === "FR"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: { src: _vm.logoFlagFR },
                                        })
                                      : _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: { src: _vm.logoFlagEN },
                                        }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(option.text))]),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "form-group",
                          attrs: { cols: "8", offset: "2" },
                        },
                        [
                          _c("div", [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("common.orig_pwd")) + " "),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("*"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _vm.originalPasswordFieldType === "checkbox"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.originalPassword,
                                        expression: "originalPassword",
                                      },
                                    ],
                                    staticClass:
                                      "form-control inputAccordionForm inputLogin h-30px",
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.originalPassword
                                      )
                                        ? _vm._i(_vm.originalPassword, null) >
                                          -1
                                        : _vm.originalPassword,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.originalPassword,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.originalPassword =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.originalPassword = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.originalPassword = $$c
                                        }
                                      },
                                    },
                                  })
                                : _vm.originalPasswordFieldType === "radio"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.originalPassword,
                                        expression: "originalPassword",
                                      },
                                    ],
                                    staticClass:
                                      "form-control inputAccordionForm inputLogin h-30px",
                                    attrs: { type: "radio" },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.originalPassword,
                                        null
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.originalPassword = null
                                      },
                                    },
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.originalPassword,
                                        expression: "originalPassword",
                                      },
                                    ],
                                    staticClass:
                                      "form-control inputAccordionForm inputLogin h-30px",
                                    attrs: {
                                      type: _vm.originalPasswordFieldType,
                                    },
                                    domProps: { value: _vm.originalPassword },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.originalPassword =
                                          $event.target.value
                                      },
                                    },
                                  }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "icon icon-password mt-2 pt-1",
                                class: [
                                  _vm.isOriginalPasswordFieldHidden
                                    ? "fa-duotone fa-eye"
                                    : "fa-duotone fa-eye-slash",
                                ],
                                on: {
                                  click: _vm.toggleOriginalPasswordVisibility,
                                },
                              }),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "form-group",
                          attrs: { cols: "8", offset: "2" },
                        },
                        [
                          _c("div", [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("common.new_pwd")) + " "),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("*"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _vm.newPasswordFieldType === "checkbox"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newPassword,
                                        expression: "newPassword",
                                      },
                                    ],
                                    staticClass:
                                      "form-control inputAccordionForm inputLogin h-30px",
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(_vm.newPassword)
                                        ? _vm._i(_vm.newPassword, null) > -1
                                        : _vm.newPassword,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.newPassword,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.newPassword = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.newPassword = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.newPassword = $$c
                                        }
                                      },
                                    },
                                  })
                                : _vm.newPasswordFieldType === "radio"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newPassword,
                                        expression: "newPassword",
                                      },
                                    ],
                                    staticClass:
                                      "form-control inputAccordionForm inputLogin h-30px",
                                    attrs: { type: "radio" },
                                    domProps: {
                                      checked: _vm._q(_vm.newPassword, null),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.newPassword = null
                                      },
                                    },
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newPassword,
                                        expression: "newPassword",
                                      },
                                    ],
                                    staticClass:
                                      "form-control inputAccordionForm inputLogin h-30px",
                                    attrs: { type: _vm.newPasswordFieldType },
                                    domProps: { value: _vm.newPassword },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.newPassword = $event.target.value
                                      },
                                    },
                                  }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "icon icon-password mt-2 pt-1",
                                class: [
                                  _vm.isNewPasswordFieldHidden
                                    ? "fa-duotone fa-eye"
                                    : "fa-duotone fa-eye-slash",
                                ],
                                on: { click: _vm.toggleNewPasswordVisibility },
                              }),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "form-group",
                          attrs: { cols: "8", offset: "2" },
                        },
                        [
                          _c("div", [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("common.new_pwd")) + " "),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("*"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _vm.confirmNewPasswordFieldType === "checkbox"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.confirmNewPassword,
                                        expression: "confirmNewPassword",
                                      },
                                    ],
                                    staticClass:
                                      "form-control inputAccordionForm inputLogin h-30px",
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.confirmNewPassword
                                      )
                                        ? _vm._i(_vm.confirmNewPassword, null) >
                                          -1
                                        : _vm.confirmNewPassword,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.confirmNewPassword,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.confirmNewPassword =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.confirmNewPassword = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.confirmNewPassword = $$c
                                        }
                                      },
                                    },
                                  })
                                : _vm.confirmNewPasswordFieldType === "radio"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.confirmNewPassword,
                                        expression: "confirmNewPassword",
                                      },
                                    ],
                                    staticClass:
                                      "form-control inputAccordionForm inputLogin h-30px",
                                    attrs: { type: "radio" },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.confirmNewPassword,
                                        null
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.confirmNewPassword = null
                                      },
                                    },
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.confirmNewPassword,
                                        expression: "confirmNewPassword",
                                      },
                                    ],
                                    staticClass:
                                      "form-control inputAccordionForm inputLogin h-30px",
                                    attrs: {
                                      type: _vm.confirmNewPasswordFieldType,
                                    },
                                    domProps: { value: _vm.confirmNewPassword },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.confirmNewPassword =
                                          $event.target.value
                                      },
                                    },
                                  }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "icon icon-password mt-2 pt-1",
                                class: [
                                  _vm.isConfirmNewPasswordFieldHidden
                                    ? "fa-duotone fa-eye"
                                    : "fa-duotone fa-eye-slash",
                                ],
                                on: {
                                  click: _vm.toggleConfirmNewPasswordVisibility,
                                },
                              }),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _c(
                "b-col",
                {
                  staticClass: "p-0 mr-2",
                  attrs: { cols: "6", sm: "4", md: "3", lg: "3", xl: "3" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.changePassword },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("common.sve")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "p-0 m-0",
                  attrs: { cols: "6", sm: "4", md: "3", lg: "3", xl: "3" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.logout },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("leftPanelTitle.lgout")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }